module.exports = __webpack_public_path__ + "static/office-763a1b02c24c6fd7dd3e834f85b33d42.svg";